<div>
  <app-capture-status-and-reason-select
    name="selectedCaptureStatusAndReasons"
    placeholder="Select Capture Status"
    [multiple]="true"
    [items]="availableCaptureStatusAndReasons"
    [(model)]="selectedCaptureStatusAndReasons"
    (modelChange)="onModelChange($event)" />
</div>